// extracted by mini-css-extract-plugin
export default {"swap":"swap_swap__lBqS7","title":"swap_title__b3laN"};